import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import PageHeader from "../../components/PageHeader";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import { useContent, SuggestionItem } from "../../hooks/content";
import useAdminGuard from "../../hooks/useAdminGuard";

import { Container, Main, ListIntro } from "./styles";

const Suggestions: React.FC = () => {
  useAdminGuard();
  const navigate = useNavigate();
  const { listSuggestions } = useContent();
  const [items, setItems] = useState<SuggestionItem[]>([]);

  const load = useCallback(async () => {
    try {
      const data = await listSuggestions();
      setItems(data);
    } catch (error) {
      console.error(error);
    }
  }, [listSuggestions]);

  useEffect(() => {
    load();
  }, [load]);

  const columns = [
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Usuário",
      dataIndex: "fromUser",
      key: "fromUser",
    },
  ];

  return (
    <Container id="page">
      <PageHeader
        title="Sugestões dos usuários"
        description="Realtime Database: nó suggestions/{uid} — toque numa linha para ver o registro completo."
        type="private"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Sugestões", active: true },
          ]}
        />
        <section>
          <h1>Lista (Firebase)</h1>
          <ListIntro>
            Campos típicos: uid, title, description, createdAt, fromUser.
          </ListIntro>
          <Table
            rowKey="uid"
            columns={columns}
            dataSource={items}
            pagination={{ hideOnSinglePage: true, pageSize: 15 }}
            onRow={(record) => ({
              onClick: () => navigate(`/suggestions/${record.uid}`),
              style: { cursor: "pointer" },
            })}
          />
        </section>
      </Main>
      <Footer />
    </Container>
  );
};

export default Suggestions;
